// "use client";

// import { motion } from "framer-motion";
// import { useInView } from "framer-motion";
// import { useRef } from "react";
// import AnimatedIcon from "../ui/animated-icon";
// import {
//   staggerContainer,
//   staggerItem,
//   fadeInUp,
//   textReveal,
//   iconHover,
// } from "../../lib/animations";

// export default function Companies() {
//   const companies = [
//     {
//       id: 1,
//       name: "Org Update",
//       icon: (
//         <div className="w-48 h-30 flex items-center justify-center">
//           <img
//             src="/logos/org-update.png"
//             alt="Org Update"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 2,
//       name: "Seller Metrics",
//       icon: (
//         <div className="w-48 h-30 flex items-center justify-center">
//           <img
//             src="/logos/seller-metrics.png"
//             alt="Seller Metrics"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 3,
//       name: "GMS",
//       icon: (
//         <div className="w-48 h-30 flex items-center justify-center">
//           <img
//             src="/logos/gms.png"
//             alt="GMS"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 4,
//       name: "One Union",
//       icon: (
//         <div className="w-30 h-20 flex items-center justify-center">
//           <img
//             src="/logos/one-union.png"
//             alt="One Union"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 5,
//       name: "Revlyx",
//       icon: (
//         <div className="w-30 h-26 flex items-center justify-center">
//           <img
//             src="/logos/revlyx.png"
//             alt="Revlyx"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 6,
//       name: "Influent",
//       icon: (
//         <div className="w-30 h-25 flex items-center justify-center">
//           <img
//             src="/logos/influent.png"
//             alt="Influent"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 7,
//       name: "Rent Upay",
//       icon: (
//         <div className="w-30 h-28 flex items-center justify-center">
//           <img
//             src="/logos/rent-upay.png"
//             alt="Rent Upay"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//     {
//       id: 8,
//       name: "Neumandate",
//       icon: (
//         <div className="w-35 h-26 flex items-center justify-center">
//           <img
//             src="/logos/neumandate.png"
//             alt="Neumandate"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       ),
//     },
//   ];

//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.1 });

//   return (
//     <motion.section
//       ref={ref}
//       className="py-16 bg-light"
//       initial="hidden"
//       animate={isInView ? "visible" : "hidden"}
//       variants={staggerContainer}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div className="text-center mb-12" variants={staggerContainer}>
//           <motion.p
//             className="text-text text-sm font-medium mb-2"
//             variants={fadeInUp}
//           >
//             Trusted by leading companies
//           </motion.p>
//           <motion.h2
//             className="text-2xl md:text-3xl font-bold text-foreground"
//             variants={textReveal}
//           >
//             We have worked worldwide
//           </motion.h2>
//         </motion.div>

//         <motion.div
//           className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-0 items-center justify-center mx-auto"
//           variants={staggerContainer}
//         >
//           {companies.map((company, index) => (
//             <motion.div
//               key={company.id}
//               className="flex flex-col items-center group cursor-pointer"
//               variants={staggerItem}
//               custom={index}
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.3 }}
//             >
//               <motion.div
//                 className=""
//                 whileHover={{
//                   scale: 1.05,
//                   transition: { duration: 0.2 },
//                 }}
//               >
//                 {company.icon}
//               </motion.div>
//               {/* <motion.span
//                 className="text-xs text-text font-medium text-center opacity-60 group-hover:opacity-100 transition-opacity duration-300"
//                 whileHover={{ y: -2 }}
//                 transition={{ duration: 0.2 }}
//               >
//                 {company.name}
//               </motion.span> */}
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     </motion.section>
//   );
// }

"use client";

import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const stats = [
  {
    value: 150,
    label: "Products Launched",
  },
  {
    value: 15,
    label: "Industries Served",
  },
  {
    value: 20,
    label: "Delivery Regions",
  },
  {
    value: 50,
    label: "Platforms Delivered",
  },
];

export default function TrustedScale() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section
      ref={ref}
      className="bg-[#F6F7F9] pt-10 pb-28"
    >
      <div className="mx-auto max-w-7xl px-6">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={
            inView
              ? { opacity: 1, y: 0 }
              : {}
          }
          transition={{ duration: 0.6 }}
          className="mx-auto max-w-5xl text-center"
        >
          <h2
            className="text-[42px] md:text-[50px] text-[#111111]"
            style={{
              fontWeight: 500,
              lineHeight: 1.08,
              letterSpacing: "-0.04em",
            }}
          >
            Trusted by Businesses Worldwide
          </h2>

          <p
            className="mx-auto mt-10 max-w-4xl text-[20px] text-[#5C6675]"
            style={{
              fontWeight: 400,
              lineHeight: 1.65,
            }}
          >
            From startups to growing enterprises,
            teams work with ZySoftec to build
            reliable, scalable software that
            delivers real business outcomes.
          </p>
        </motion.div>

        {/* Stats Cards */}
        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4 max-w-5xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{
                opacity: 0,
                y: 30,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                    }
                  : {}
              }
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              className="
                relative
                overflow-hidden
                rounded-[24px]
                bg-[#FCFCFD]
                px-9
                pt-8
                pb-7
                min-h-[180px]
              "
              style={{
                boxShadow:
                  "0 1px 3px rgba(15,23,42,0.02)",
              }}
            >
              {/* Border Effect */}
              <div
                className="absolute inset-0 rounded-[24px] pointer-events-none"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(122,111,240,0.85) 0%, rgba(122,111,240,0.35) 12%, rgba(122,111,240,0.12) 20%, transparent 40%)",
                  mask:
                    "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  WebkitMask:
                    "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  padding: "1px",
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                }}
              />

              <div className="relative z-10">
                <div
                  className="text-[50px] text-[#111111]"
                  style={{
                    fontWeight: 500,
                    lineHeight: 1,
                    letterSpacing: "-0.03em",
                  }}
                >
                  {inView && (
                    <CountUp
                      end={stat.value}
                      duration={2}
                    />
                  )}
                  +
                </div>

                <div className="mt-4 mb-5 h-[3px] w-[58px] rounded-full bg-[#7A6FF0]" />

                <p
                  className="text-[18px] text-[#5B6574]"
                  style={{
                    fontWeight: 400,
                  }}
                >
                  {stat.label}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}